import React from 'react';
import dynamic from 'next/dynamic';

const Newsletter = dynamic(() =>
  import('@components/organisms/Newsletter/Newsletter').then((module) => module.Newsletter),
);

export default function PageContentElementNewsletterBoxes(element, index, data) {
  if (!element?.newsletters) return null;

  return <Newsletter newsletter={element?.newsletters} hasBackground={!data?.power_branding} />;
}
